<mbs-card-group>
  <ng-container *ngTemplateOutlet="credsTmp"></ng-container>
</mbs-card-group>
<mbs-card-group>
  <ng-container *ngTemplateOutlet="keystoneTmp"></ng-container>
</mbs-card-group>
<mbs-card-group>
  <ng-container *ngTemplateOutlet="optionsTmp"></ng-container>
</mbs-card-group>

<ng-template #credsTmp>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.user"
      [boldLabel]="true"
      [formControl]="userNameControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.username' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.username' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input-password
      [attr.data-e2e]="e2eLocators.apiKey"
      [autocomplete]="'new-password'"
      [boldLabel]="true"
      [disabledEye]="apiKeyControl.value === fakeSecretKey"
      [formControl]="apiKeyControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.apiKey' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.apiKey' | i18next"
      [showRequiredMark]="false"></mbs-input-password>
  </mbs-form-group>

  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.endpoint"
      [boldLabel]="true"
      [formControl]="endpointControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.authService' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.authService' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
</ng-template>

<ng-template #keystoneTmp>
  <mbs-form-group>
    <mbs-select
      [attr.data-e2e]="e2eLocators.keystoneVersion"
      [bindLabel]="'label'"
      [bindValue]="'value'"
      [boldLabel]="true"
      [clearable]="false"
      [formControl]="keystoneVersionControl"
      [items]="keystoneVersions"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.keystoneVersion' | i18next">
    </mbs-select>
  </mbs-form-group>
  @if (keystoneVersion === KeystoneVersion.Second) {
    <ng-container *ngTemplateOutlet="secondVersionTmp"></ng-container>
  }
  @if (keystoneVersion === KeystoneVersion.Third) {
    <ng-container *ngTemplateOutlet="thirdVersionTmp"></ng-container>
  }
</ng-template>

<ng-template #thirdVersionTmp>
  <mbs-form-group>
    <div class="row">
      <div class="col">
        <mbs-select
          [attr.data-e2e]="e2eLocators.domainIdentifier"
          [bindLabel]="'label'"
          [bindValue]="'value'"
          [boldLabel]="true"
          [clearable]="false"
          [formControl]="domainIdentifierControl"
          [items]="domainIdentifiers"
          [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.domainIdentifier' | i18next">
        </mbs-select>
      </div>
      <div class="col">
        @if (domainIdentifier === DomainIdentifier.Name) {
          <mbs-input
            [attr.data-e2e]="e2eLocators.domainName"
            [boldLabel]="true"
            [formControl]="domainControl"
            [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.domainName' | i18next"
            [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.domainName' | i18next"
            [showRequiredMark]="false"></mbs-input>
        }
        @if (domainIdentifier === DomainIdentifier.Id) {
          <mbs-input
            [attr.data-e2e]="e2eLocators.domainId"
            [boldLabel]="true"
            [formControl]="domainControl"
            [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.domainID' | i18next"
            [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.domainID' | i18next"
            [showRequiredMark]="false"></mbs-input>
        }
      </div>
    </div>
  </mbs-form-group>
  <ng-container *ngTemplateOutlet="scopeTmp"></ng-container>
</ng-template>

<ng-template #scopeTmp>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.useScope"
      [boldLabel]="true"
      [formControl]="useScopeControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.useScope' | i18next"></mbs-checkbox>
  </mbs-form-group>

  @if (useScope) {
    <mbs-form-group>
      <div class="row">
        <div class="col">
          <mbs-select
            [attr.data-e2e]="e2eLocators.projectIdentifier"
            [bindLabel]="'label'"
            [bindValue]="'value'"
            [boldLabel]="true"
            [clearable]="false"
            [formControl]="projectIdentifierControl"
            [items]="projectIdentifiers"
            [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.projectIdentifier' | i18next">
          </mbs-select>
        </div>
        <div class="col">
          @if (projectIdentifier === ProjectIdentifier.Name) {
            <mbs-input
              [attr.data-e2e]="e2eLocators.projectName"
              [boldLabel]="true"
              [formControl]="projectControl"
              [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.projectName' | i18next"
              [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.projectName' | i18next"
              [showRequiredMark]="false"></mbs-input>
          }
          @if (projectIdentifier === ProjectIdentifier.Id) {
            <mbs-input
              [attr.data-e2e]="e2eLocators.projectId"
              [boldLabel]="true"
              [formControl]="projectControl"
              [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.projectID' | i18next"
              [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.projectID' | i18next"
              [showRequiredMark]="false"></mbs-input>
          }
        </div>
      </div>
    </mbs-form-group>
  }
</ng-template>

<ng-template #secondVersionTmp>
  <mbs-form-group>
    <div class="row">
      <div class="col">
        <mbs-select
          [attr.data-e2e]="e2eLocators.tenantIdentifier"
          [bindLabel]="'label'"
          [bindValue]="'value'"
          [boldLabel]="true"
          [clearable]="false"
          [formControl]="tenantIdentifierControl"
          [items]="tenantIdentifiers"
          [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.tenantIdentifier' | i18next">
        </mbs-select>
      </div>
      <div class="col">
        @if (tenantIdentifier === TenantIdentifier.Name) {
          <mbs-input
            [attr.data-e2e]="e2eLocators.tenantName"
            [boldLabel]="true"
            [formControl]="tenantControl"
            [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.tenantName' | i18next"
            [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.tenantName' | i18next"
            [showRequiredMark]="false"></mbs-input>
        }
        @if (tenantIdentifier === TenantIdentifier.Id) {
          <mbs-input
            [attr.data-e2e]="e2eLocators.tenantIdCtrl"
            [formControl]="tenantControl"
            [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.tenantID' | i18next"
            [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.tenantID' | i18next"
            [showRequiredMark]="false"></mbs-input>
        }
      </div>
    </div>
  </mbs-form-group>
</ng-template>

<ng-template #optionsTmp>
  <mbs-input-label
    [boldLabel]="true"
    [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.options' | i18next"></mbs-input-label>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.privateStorage"
      [formControl]="privateStorageControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.checkCredentials' | i18next"></mbs-checkbox>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.useInternalUrls"
      [formControl]="useInternalUrlsControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.userInternalURLs' | i18next"></mbs-checkbox>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.ignoreCertificates"
      [formControl]="ignoreCertificatesControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.ignoreCertificate' | i18next"></mbs-checkbox>
  </mbs-form-group>
</ng-template>
